import { remittanceServices } from '../../../mocks/services';

export default function TopBanner() {
  const best = remittanceServices.find(s => s.id === 'wise');

  return (
    <div className="bg-gradient-to-r from-green-600 to-emerald-500 text-white py-3.5 px-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 text-sm font-semibold text-center">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-white animate-pulse flex-shrink-0" />
          <span>
            <strong>Mejor opción hoy:</strong> Wise ofrece el menor costo total para enviar dinero a Venezuela
          </span>
        </div>
        {best && (
          <a
            href={best.link}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex-shrink-0 bg-white text-green-700 hover:bg-green-50 font-bold text-xs px-4 py-1.5 rounded-full transition-all cursor-pointer whitespace-nowrap hover:scale-105"
          >
            Enviar con Wise →
          </a>
        )}
      </div>
    </div>
  );
}
